import { Component } from "react";
import RectButton from "../../components/ui/button/RectButton";
import TitleBar from "../../components/ui/TitleBar";
import Template from "../../components/Template";
// import TemplateEmpty from "../../components/assets/images/template-empty.svg";
import Lottie from 'react-lottie';
import * as EmptyTemplatesData from '../../components/assets/json/lottie/empty-templates.json'

import "./style.scss";

class Templates extends Component {

    state = {
        adding: false,
        templates: [
        ]
    }

    addNewTemplateHandler = () => {
        if(!this.state.adding) this.setState({ adding:true, templates: [{ id:this.state.templates.length, name: "", title: "", text: "Template text.", signed: true, editing: true }, ...this.state.templates] });
    }

    deleteHandler = (i) => {
        let templates = this.state.templates;
        templates.splice(i, 1);
        this.setState({ templates: templates });
    }

    updateData = (i, value)=>{
        let templates = this.state.templates;
        if(value) templates[i] = value;
        else templates.splice(i, 1);
        this.setState({ templates: templates, adding:false });
    }

    render() {
        let left = [];
        let right = [];
        let side = 1;
        console.log(this.state.templates)
        this.state.templates.forEach((obj, i) => {
            let template = <Template key={obj.id} id={obj.id} name={obj.name} title={obj.title} text={obj.text} signed={true} mergeField={obj.mergeField} signature={obj.signature} editing={obj.editing} onDelete={this.deleteHandler} onSave={(data)=>this.updateData(i, data)} />
            side % 2 === 0 ? right.push(template) : left.push(template);
            side++;
        });

        return (
            <>
                <div className="full-container templates">
                    <TitleBar title="Message Templates">
                        {/* <RectButton className="add-new-template" text="ADD NEW TEMPLATE" onClick={this.addNewTemplateHandler}><div className="plus-icon"></div></RectButton> */}
                        <RectButton className="add-new-template" text="ADD NEW TEMPLATE" onClick={this.addNewTemplateHandler}></RectButton>
                    </TitleBar>
                    <section className="section-box row not-expand">
                        {
                            !this.state.templates.length ?
                                <div className="empty">
                                    <div className="empty-image">
                                        {/* <img src={TemplateEmpty} alt="Empty" /> */}
                                        <Lottie options={{
                                            loop: false,
                                            autoplay: true,
                                            animationData: EmptyTemplatesData.default,
                                        }}
                                            height="100%"
                                            width="100%" />
                                    </div>
                                    <h2>You have 0 templates.</h2>
                                    <p>Save time and streamline your process by creating templates.</p>
                                    <RectButton text="ADD NEW TEMPLATE" onClick={this.addNewTemplateHandler} />
                                </div>
                                :
                                <>
                                    <section className="section-box column">
                                        {left}
                                    </section>

                                    <section className="section-box column">
                                        {right}
                                    </section>
                                </>
                        }
                    </section>
                </div>
            </>
        )
    }
}

export default Templates;